export default __webpack_public_path__ + "static/media/Inter-UI-BlackItalic.34d5f779.woff2";